import { Pipe, PipeTransform } from '@angular/core';
import { Priority, PriorityUtility, ColorUtility } from '@jms/model';

@Pipe({
    name: 'prioritycolor',
    pure: false,
    standalone: true
})
export class PriorityColorPipe implements PipeTransform {
    transform(priority: Priority) {
        if (!priority) {
            return 'transparent';
        }

        return PriorityUtility.getColor(priority);
    }
}

@Pipe({
    name: 'textprioritycolor',
    pure: false,
    standalone: true
})
export class TextPriorityColorPipe implements PipeTransform {
    transform(priority: Priority) {

        let color = PriorityUtility.getColor(priority);
        if (!color) {
            return null;
        }

        if (color === 'transparent') {
            color = '#ffffff';
        }

        return ColorUtility.idealTextColor(color);
    }
}
